export const NEXT_ID = '__next'
export const PORTAL_ID = '__portal'
